import './App.css';

function App() {
  return (
    <div className="App">
      <div className="content">
        <h1 className="brand">Surreal Black</h1>
        <p className="tagline">Coming Soon</p>
      </div>
    </div>
  );
}

export default App;
